<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Request Transaction</h1>

      <breadcrumb name="PRIZE_SUMMARY_REQUEST_TRANSACTION"></breadcrumb>

      <div class="page-header-right">
        Select Period
        <date-picker
          v-model="fromTo"
          type="date"
          value-type="format"
          format="YYYY-MM-DD"
          range
          class="mx-3"
          placeholder="Select date range"
        ></date-picker>
      </div>
      <div class="page-header-actions"></div>
    </div>

    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <vue-good-table
              ref="table"
              mode="remote"
              :rows="list"
              :columns="columns"
              :totalRows="totalRecords"
              :sort-options="sortOption"
              :pagination-options="pagination"
              @on-search="onSearch"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPerPageChange"
              :search-options="{ ...searchOption, trigger: 'enter' }"
            >
              <div slot="table-actions">
                <div class="Excel">
                  <button
                    @click="exportToExcel"
                    class="btn btn-primary"
                    :disabled="!canExport"
                  >
                    <i class="mdi mdi-file-excel-outline"></i>
                    Export to Excel
                  </button>
                </div>
              </div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import vueGoodTableMixins from "@/mixins/vue-good-table";

import { prizeService } from "@/api/client";
import { tableColumns } from "@/views/prize/request_transaction/model";

export default {
  name: "PrizeRequestTransaction",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      fromTo: [],
      columns: tableColumns,
    };
  },

  watch: {
    async fromTo() {
      await this.onPeriodChange();
    },

    async "$route.query"() {
      await this.fetch();
      this.initialTableState();
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
    this.initialSearchValues();
  },

  computed: {
    canExport() {
      const from = this.fromTo[0];
      const to = this.fromTo[1];
      return from && dayjs(from).isValid() && to && dayjs(to).isValid();
    },
  },

  methods: {
    getParams() {
      let params = {
        from: this.fromTo[0],
        to: this.fromTo[1],
      };

      const { sortBy, sortDir, perPage, page, searchTerm } = this.$route.query;

      const pageSize = perPage || this.pagination.perPage;

      if (sortBy) {
        params.order_by = sortBy;
      }

      if (sortDir) {
        params.desc = sortDir == "desc" ? 1 : 0;
      }

      if (searchTerm) {
        params.search = searchTerm;
      }

      if (page) {
        params.start = page ? (page - 1) * pageSize : 0;
      }

      params.count = pageSize || 10;

      return params;
    },

    isValidPeriod() {
      const { from, to } = this.$route.query;

      if (!from || !dayjs(from).isValid()) {
        return false;
      }

      if (!to || !dayjs(to).isValid()) {
        return false;
      }

      return true;
    },

    async fetch() {
      if (!this.isValidPeriod()) {
        return;
      }

      const params = this.getParams();

      const { data, total_records } =
        await prizeService.fetchRequestTransaction(params);

      this.list = data;
      this.totalRecords = total_records;
    },

    async exportToExcel() {
      try {
        const response = await prizeService.exportRequestTransaction({
          from: this.fromTo[0],
          to: this.fromTo[1],
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });

        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = `export_prize_request_transaction_${new Date().getTime()}.xlsx`;
        a.click();
      } catch (error) {
        console.log(error);
      }
    },

    onPeriodChange() {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            from: this.fromTo[0],
            to: this.fromTo[1],
          }),
        })
        .catch((err) => {});
    },

    initialSearchValues() {
      const { from, to } = this.$route.query;

      if (from) {
        this.fromTo = [from, to || from];
        this.fetch();
      }
    },
  },
};
</script>

<style scoped>
.page-header-right {
  position: absolute;
  top: 40px;
  bottom: 0;
  right: 30px;
}
.page-header-actions {
  margin-top: 40px;
  position: absolute;
  bottom: 20px;
}
.panel {
  margin-top: 3px;
}
.show_entries {
  margin-top: 20px;
}
.Excel {
  margin: auto 1rem;
}
</style>
